import Parse from 'parse'
import ParseViewModel from '@/utils/parse-object-pojo'

export const Announcement = Parse.Object.extend('Announcement');

export const AnnouncementVM = ParseViewModel(Announcement, [
    'title',
    'description',
]);

export default {
    Announcement,
    AnnouncementVM,
}



// WEBPACK FOOTER //
// ./src/models/announcement.js